<template>
  <loader
    v-if="!settProfile || loading"
    :class="$style.loader"
  />
  <div
    v-else
    :class="[$style.form, $style.formColumn]"
  >
    <div :class="$style.formTitle">
      {{ $t('settings.advancedSearchCategories.personalData') }}
    </div>
    <div :class="$style.formColumn">
      <div :class="$style.formInput">
        <input
          :id="personalData[0].key"
          v-model="isAllChecked"
          type="checkbox"
          :name="personalData[0].name"
          :value="personalData[0].name"
          @change="onItemChange(personalData[0])"
        >
        <label :for="personalData[0].key">{{ personalData[0].name }}</label>
      </div>
      <div
        v-for="item in personalData.slice(1)"
        :key="item.key"
        :class="$style.formInput"
      >
        <input
          :id="item.key"
          v-model="item.checked"
          type="checkbox"
          :name="item.name"
          :value="item.name"
          @change="onItemChange(item)"
        >
        <label :for="item.key">{{ item.name }}</label>
      </div>
    </div>
  </div>
</template>

<script>
  import { getNeiroSett } from '@/api/methods/settings';
  import { PERSONAL_DATA_KEYS, PERSONAL_DATA_DEFAULTS } from '@/views/settings/const';
  import { isEqual, cloneDeep } from 'lodash';
  import Loader from '@/components/common/blocks/loader.vue';

  export default {
    components: {
      Loader,
    },
    data() {
      return {
        loading: false,
        initNeiroSett: {},
        neiroSett: {},
        personalData: [
          {
            key: PERSONAL_DATA_KEYS.CHECK_PERS_DATA,
            name: this.$t('settings.advancedSearchCategories.dataDetection'),
            checked: false,
          },
          {
            key: PERSONAL_DATA_KEYS.CHECK_IN_FILES,
            name: this.$t('settings.advancedSearchCategories.dataDetectionFiles'),
            checked: false,
          },
          {
            key: PERSONAL_DATA_KEYS.CHECK_IN_PRINT,
            name: this.$t('settings.advancedSearchCategories.dataDetectionPrinted'),
            checked: false,
          },
          {
            key: PERSONAL_DATA_KEYS.CHECK_IN_MESSENGER_TEXTS,
            name: this.$t('settings.advancedSearchCategories.dataDetectionMessages'),
            checked: false,
          },
          {
            key: PERSONAL_DATA_KEYS.AUDIO_TO_TEXT,
            name: this.$t('settings.advancedSearchCategories.speechToText'),
            checked: false,
          },
        ],
      };
    },
    computed: {
      isAllChecked: {
        get() {
          return this.personalData.slice(1, -1).some((item) => item.checked);
        },
        set(value) {
          this.personalData.slice(1, -1).forEach((item) => {
            item.checked = value;
          });
        },
      },
      computerId() {
        return this.$route.params.computer;
      },
      settProfile() {
        return this.$store.getters['settings/profile'];
      },
      isNeiroEqual() {
        return isEqual(this.initNeiroSett, this.neiroSett);
      },
    },
    watch: {
      settProfile: {
        async handler(newVal) {
          if (newVal) await this.getNeiroData(newVal);
        },
        immediate: true,
      },
    },
    async mounted() {
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/cancel') {
            this.setPersonalData();
          }
        },
      });
    },
    methods: {
      onItemChange({ key, checked }) {
        if (key === PERSONAL_DATA_KEYS.CHECK_PERS_DATA) {
          this.personalData.slice(0, -1).forEach((item) => {
            this.$set(this.neiroSett, item.key, this.isAllChecked);
          });
        } else {
          this.$set(this.neiroSett, key, checked);
          if (this.isAllChecked !== this.neiroSett[PERSONAL_DATA_KEYS.CHECK_PERS_DATA]) {
            this.$set(this.neiroSett, PERSONAL_DATA_KEYS.CHECK_PERS_DATA, this.isAllChecked);
          }
        }
        if (!this.isNeiroEqual) this.$store.commit('settings/addNeiroSettings', this.neiroSett);
        else this.$store.commit('settings/addNeiroSettings', {});
      },
      async getNeiroData(profile) {
        try {
          this.loading = true;
          const { data } = await getNeiroSett(profile, 10);
          if (data?.success) {
            this.initNeiroSett = data.result || cloneDeep(PERSONAL_DATA_DEFAULTS);
            this.setPersonalData();
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
      setPersonalData() {
        this.neiroSett = cloneDeep(this.initNeiroSett);
        this.personalData = this.personalData.map((item) => ({
          ...item,
          checked: this.neiroSett[item.key] ?? false,
        }));
      },
    },
  };
</script>

<style lang="scss" module>
  .form {
    font-style: normal;
    font-size: 14px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    flex: 2;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
  }

  .formLeft {
    flex: 1;
  }

  .formColumn {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .formTitle {
    font-size: 15px;
    padding: 10px;
  }

  .formInput {
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    padding: 10px;
    margin-left: 10px;

    & * {
      cursor: pointer;
    }

    & input {
      flex-shrink: 0;
      margin: 0;
    }
  }

  .formInput:first-child,
  .formInput:last-child {
    margin-left: 0;
  }
</style>
